export const isTenant559042084949 = (tenantId: number) =>
  tenantId === 559042084949
